import React, { useCallback, useEffect, useState } from 'react';

import _ from 'lodash';

import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  makeStyles,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import { useSelector } from 'react-redux';

import surveyEndpoint from 'app/api/services/surveyEndpoint';
import notification from 'app/config/notification';
import { FormattedMessage, injectIntl } from 'react-intl';
import { VEHICLE_REPORT_SITUATION } from 'app/utils/constants';

import styles from './styles';
const useStyles = makeStyles(styles);

const Irregularities = props => {
  const classes = useStyles();
  const {
    canEdit,
    irregularities,
    setIrregularities,
    situation,
    setSituation,
    intl,
    setFieldValue,
    values,
  } = props;

  const [loadingGeral, setLoadingGeral] = useState(true);
  const [loadings, setLoadings] = useState([]);
  const [totalPoints, setTotalPoints] = useState('');
  const [didntPresentVehicle, setdidntPresentVehicle] = useState(values.boVeiculoAusente || false);
  const [oldSituation, setOldSituation] = useState(situation);

  const [severity, setSeverity] = useState('');
  const [defects, setDefects] = useState([]);
  const [positions, setPositions] = useState([]);
  const [actions, setActions] = useState([]);
  const [filteredSubitemComponent, setFilteredSubitemComponent] = useState([]);

  const systemClassification = useSelector(state => state.survey.systemClassification);
  const subitemComponent = useSelector(state => state.survey.subitemComponent);

  const changeElement = async index => {
    const temp = [...irregularities];
    const tempDefects = [...defects];
    const tempPositions = [...positions];
    const tempActions = [...actions];
    const tempSubitemComponent = [...filteredSubitemComponent];
    if (index === undefined) {
      temp.push({});
    } else {
      if (window.confirm('Deseja excluir este item?')) {
        const load = [...loadings];
        load[index] = true;
        setLoadings(load);
        try {
          if (temp[index].cdVistoriaVeiculoIrreg) {
            await surveyEndpoint.deleteIrregularity(temp[index].cdVistoriaVeiculoIrreg);
          }
          temp.splice(index, 1);
          tempDefects.splice(index, 1);
          tempPositions.splice(index, 1);
          tempActions.splice(index, 1);
          tempSubitemComponent.splice(index, 1);
        } catch (error) {
          notification(
            intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.IRREGULARITY_DELETE_ERROR' }),
            { toastId: 'IRREGULARITY_DELETE_ERROR', type: 'success' }
          );
        }
        load[index] = false;
        setLoadings(load);
      }
    }
    values.irregularidades = temp;
    setIrregularities(temp);
    setDefects(tempDefects);
    setPositions(tempPositions);
    setActions(tempActions);
    setFilteredSubitemComponent(tempSubitemComponent);
  };

  const fillDefects = useCallback(
    async (index, def, cdClassificacaoSistema, cdSubitemComponente) => {
      const load = [...loadings];
      load[index] = true;
      setLoadings(load);
      const defTemp = [...def];
      let data = [];
      try {
        const response = await surveyEndpoint.getDefectClassification(
          cdClassificacaoSistema,
          cdSubitemComponente
        );
        if (response?.status === 200 && response?.data) {
          data = [...response.data];
          defTemp[index] = data;
        }
      } catch (error) {}
      load[index] = false;
      setLoadings(load);
      return defTemp;
    },
    [loadings]
  );

  useEffect(() => {
    const init = async () => {
      let points = 0;
      let previousSeverity = 0;
      let majorSeverity = '';
      let defTemp = [...defects];
      for (const irr of irregularities) {
        if (irr.defeito?.pontuacaoDefeito?.nuPontuacaoDefeito) {
          const actualPoint = Number(irr.defeito.pontuacaoDefeito.nuPontuacaoDefeito);
          if (actualPoint > previousSeverity) {
            majorSeverity = irr.defeito.pontuacaoDefeito.dePontuacaoDefeito;
          }
          points += actualPoint;
          previousSeverity = actualPoint;
        }
      }
      setDefects(defTemp);
      setTotalPoints(points);
      setSeverity(majorSeverity);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [irregularities]);

  useEffect(() => {
    const init = async () => {
      setLoadingGeral(true);
      let index = 0;
      let defTemp = [...defects];

      const positionsInit = [...positions];
      const actionsInit = [...actions];
      const subItemTemp = [...filteredSubitemComponent];
     
      for (const irr of irregularities) {
        if (irr.defeito?.cdClassificacaoSistema && irr.defeito?.cdSubitemComponente) {
          defTemp = await fillDefects(
            index,
            defTemp,
            irr.defeito?.cdClassificacaoSistema,
            irr.defeito?.cdSubitemComponente
          );
        }
        positionsInit[index] = [];
        actionsInit[index] = [];
        subItemTemp[index] = subitemComponent.filter(s => s.cdClassificacaoSistema === irr.defeito?.cdClassificacaoSistema);
  
        for (const def of defTemp[index]) {
          if (!actionsInit[index].includes(def.deAcao)) {
            actionsInit[index].push(def.deAcao);
          }
          if (!positionsInit[index].includes(def.cdClassificacaoDefeito)) {
            positionsInit[index].push(def);
          }
        }

        actionsInit[index] = _.orderBy(actionsInit[index], ['deAcao']);
        index++;
      }
      setPositions(positionsInit);
      setActions(actionsInit);
      setFilteredSubitemComponent(subItemTemp);
      setDefects(defTemp);
      setLoadingGeral(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetActionsAndPositions = index => {
    const tempActions = [...actions];
    tempActions[index] = [];
    setActions(tempActions);

    const tempPositions = [...positions];
    tempPositions[index] = [];
    setPositions(tempPositions);
  };

  const onChangeField = async (e, index) => {
    const name = e.target.name;
    const value = e.target.value;
    const temp = _.cloneDeep(irregularities);
    const def = [...defects];

    const tempInt = temp[index];

    if (name === 'deObservacao') {
      tempInt[name] = value;
    } else if (name === 'cdClassificacaoSistema') {
      tempInt['defeito'] = {
        cdClassificacaoSistema: Number(value),
      };

      const subItemTemp = [...filteredSubitemComponent];
      subItemTemp[index] = subitemComponent.filter(s => s.cdClassificacaoSistema === Number(value));
      setFilteredSubitemComponent(subItemTemp);

      resetActionsAndPositions(index);
    } else if (name === 'cdSubitemComponente' && tempInt['defeito']['cdClassificacaoSistema']) {
      tempInt['defeito']['cdSubitemComponente'] = Number(value);
      const data = await fillDefects(
        index,
        def,
        tempInt['defeito']['cdClassificacaoSistema'],
        tempInt['defeito']['cdSubitemComponente']
      );
      setDefects(data);

      const actionsTemp = [...actions];
      actionsTemp[index] = [];
      data[index].forEach(def => {
        if (!actionsTemp[index].includes(def.deAcao)) {
          actionsTemp[index].push(def.deAcao);
        }
      });
      setActions(actionsTemp);
    } else if (name === 'deAcao') {
      tempInt['defeito'][name] = value;
      if (defects[index]) {
        const temp = [...positions];
        temp[index] = _.orderBy(
          defects[index].filter(def => {
            if (def.deAcao === value) {
              return true;
            }
            return false;
          }),
          ['deAcao']
        );
        setPositions(temp);
      }
    } else if (name === 'cdClassificacaoDefeito') {
      tempInt[name] = value;
      const found = _.find(def[index], [name, Number(value)]);
      if (found) {
        tempInt['defeito'] = found;
      }
    }
    temp[index] = tempInt;
    setIrregularities(temp);
  };

  const checkDidntPresentVehicle = e => {
    const checked = e?.target?.checked;
    setdidntPresentVehicle(checked);
    setFieldValue('boVeiculoAusente', checked);
    if (checked) {
      setOldSituation(situation);
      setSituation(VEHICLE_REPORT_SITUATION.REPROVADO.description.toUpperCase());
    } else {
      setSituation(oldSituation);
    }
  };

  if (loadingGeral) {
    return (
      <div className={classes.loadingUser}>
        <CircularProgress size={20} />
      </div>
    );
  }

  return (
    <>
      <Grid item xs={6}>
        <h2 className={classes.title}>Irregularidades</h2>
      </Grid>
      {!didntPresentVehicle && (
        <Grid item xs={6}>
          {canEdit && (
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => changeElement()}
              className={classes.addButton}
            >
              <AddIcon /> Adicionar Irregularidade
            </Button>
          )}
        </Grid>
      )}

      <Grid item xs={12}>
        <FormControlLabel
          className={classes.filterLabel}
          onClick={event => {
            event.stopPropagation();
            checkDidntPresentVehicle(event);
          }}
          disabled={!canEdit}
          onFocus={event => event.stopPropagation()}
          control={<Checkbox color="secondary" checked={didntPresentVehicle} />}
          label={<FormattedMessage id="LABELS.SERVICES.DIDNT_PRESENT_VEHICLE" />}
        />
      </Grid>

      {!didntPresentVehicle && (
        <>
          <Grid item xs={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell
                    className={classes.headTableCell}
                    align="left"
                    style={{ width: '230px' }}
                  >
                    Classificação de Sistema*
                  </TableCell>
                  <TableCell
                    className={classes.headTableCell}
                    align="left"
                    style={{ width: '230px' }}
                  >
                    Subitem Componentes*
                  </TableCell>
                  <TableCell
                    className={classes.headTableCell}
                    align="left"
                    style={{ width: '170px' }}
                  >
                    Ação*
                  </TableCell>
                  <TableCell
                    className={classes.headTableCell}
                    align="left"
                    style={{ width: '170px' }}
                  >
                    Posição*
                  </TableCell>
                  <TableCell
                    className={classes.headTableCell}
                    align="left"
                    style={{ width: '100px' }}
                  >
                    Pontuação
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    Observação
                  </TableCell>
                  {canEdit && (
                    <TableCell className={classes.headTableCell} align="left"></TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {irregularities.map((row, indexRow) => {
                  return (
                    <TableRow key={`irr-row-${indexRow}`} className={classes.tableRow}>
                      <TableCell align="left">
                        <FormControl
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          disabled={!canEdit}
                        >
                          <Select
                            native
                            name="cdClassificacaoSistema"
                            onChange={e => onChangeField(e, indexRow)}
                            error={!row.defeito?.cdClassificacaoSistema && !!row.error}
                            value={row.defeito?.cdClassificacaoSistema || ''}
                          >
                            <option value="" />
                            {systemClassification.map((clss, index) => {
                              return (
                                <option
                                  key={`class-sys-${index}`}
                                  value={clss.cdClassificacaoSistema}
                                >
                                  {clss.deClassificacaoSistema}
                                </option>
                              );
                            })}
                          </Select>
                          {!row.defeito?.cdClassificacaoSistema && !!row.error ? (
                            <FormHelperText>Campo Obrigatório</FormHelperText>
                          ) : null}
                        </FormControl>
                      </TableCell>
                      <TableCell align="left">
                        <FormControl
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          disabled={!canEdit}
                        >
                          <Select
                            native
                            name="cdSubitemComponente"
                            onChange={e => onChangeField(e, indexRow)}
                            error={!row.defeito?.cdSubitemComponente && !!row.error}
                            value={row.defeito?.cdSubitemComponente || ''}
                          >
                            <option value="" />
                            {filteredSubitemComponent[indexRow] &&
                              filteredSubitemComponent[indexRow].map((clss, index) => {
                              return (
                                <option key={`sub-${index}`} value={clss.cdSubitemComponente}>
                                  {clss.deSubitemComponente}
                                </option>
                              );
                            })}
                          </Select>
                          {!row.defeito?.cdClassificacaoSistema && !!row.error ? (
                            <FormHelperText>Campo Obrigatório</FormHelperText>
                          ) : null}
                        </FormControl>
                      </TableCell>
                      <TableCell align="left">
                        {loadings[indexRow] && (
                          <div className={classes.centerProgress}>
                            <CircularProgress size={20} />
                          </div>
                        )}
                        {!loadings[indexRow] && (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            disabled={!canEdit}
                          >
                            <Select
                              native
                              name="deAcao"
                              onChange={e => onChangeField(e, indexRow)}
                              error={!row.defeito?.deAcao && !!row.error}
                              value={row.defeito?.deAcao || ''}
                            >
                              <option value="" />
                              {actions[indexRow] &&
                                actions[indexRow].map((deAcao, index) => {
                                  return (
                                    <option key={`class-def-${index}`} value={deAcao}>
                                      {deAcao}
                                    </option>
                                  );
                                })}
                            </Select>
                            {!row.defeito?.cdClassificacaoSistema && !!row.error ? (
                              <FormHelperText>Campo Obrigatório</FormHelperText>
                            ) : null}
                          </FormControl>
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {loadings[indexRow] && (
                          <div className={classes.centerProgress}>
                            <CircularProgress size={20} />
                          </div>
                        )}
                        {!loadings[indexRow] && (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            disabled={!canEdit}
                          >
                            <Select
                              native
                              name="cdClassificacaoDefeito"
                              onChange={e => onChangeField(e, indexRow)}
                              error={!row.defeito?.cdClassificacaoDefeito && !!row.error}
                              value={row.defeito?.cdClassificacaoDefeito || ''}
                            >
                              <option value="" />
                              {positions[indexRow] &&
                                positions[indexRow].map((clss, index) => {
                                  return (
                                    <option
                                      key={`class-def-${index}`}
                                      value={clss.cdClassificacaoDefeito}
                                    >
                                      {clss.dePosicao}
                                    </option>
                                  );
                                })}
                            </Select>
                            {!row.defeito?.cdClassificacaoSistema && !!row.error ? (
                              <FormHelperText>Campo Obrigatório</FormHelperText>
                            ) : null}
                          </FormControl>
                        )}
                      </TableCell>

                      <TableCell align="left">
                        {loadings[indexRow] && (
                          <div className={classes.centerProgress}>
                            <CircularProgress size={20} />
                          </div>
                        )}
                        {!loadings[indexRow] && (
                          <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            disabled={true}
                            value={row.defeito?.pontuacaoDefeito?.nuPontuacaoDefeito || ''}
                            name="nuPontuacaoDefeito"
                          />
                        )}
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          variant="outlined"
                          margin="dense"
                          disabled={!canEdit}
                          fullWidth
                          name="deObservacao"
                          value={row.deObservacao || ''}
                          onChange={e => onChangeField(e, indexRow)}
                        />
                      </TableCell>
                      {canEdit && (
                        <TableCell align="right">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={e => changeElement(indexRow)}
                            className={classes.btnSigleAction}
                            size="small"
                          >
                            <DeleteIcon fontSize="inherit" />
                          </Button>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={7}></Grid>
          <Grid item xs={2}>
            <TextField
              variant="outlined"
              margin="dense"
              label="Total de pontos"
              disabled={!canEdit}
              fullWidth
              name="totalPontos"
              value={totalPoints}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              variant="outlined"
              margin="dense"
              label="Maior Gravidade"
              disabled={!canEdit}
              fullWidth
              value={severity}
              name="maiorGravidade"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default injectIntl(Irregularities);
